module.exports = __webpack_public_path__ + "static/media/adult-beard-concentrated-concentration.531a26cf.jpg";